import { get, post, put, del } from '../../actions/apiMethods';

const crud = (slug) => ({
  fetchAll: () => get(`mms/${slug}`),
  fetchById: (id) => get(`mms/${slug}/${id}`),
  create: (json) => post(`mms/${slug}`, json),
  update: (id, json) => put(`mms/${slug}/${id}`, json),
  remove: (id) => del(`mms/${slug}/${id}`),
  removeMultiple: (ids) => post(`mms/${slug}/delete`, { ids }),
});

export const smtpConfig = {
  fetch: () => get('mms/smtp_config'),
  create: json => post('mms/smtp_config', json),
  test: json => post('mms/smtp_config/test', json)
};

export const ticket = {
  ticket: {
    ...crud('ticket'),
    archive: (ids) => post(`mms/ticket/archive`, ids),
    log: {
      fetchById: (id) => get(`mms/ticket/${id}`),
      create: (id, json) => post(`mms/ticket/${id}`, json),
    },
    follower: {
      create: (ticket_id, json) => post(`mms/ticket/${ticket_id}/follower`, json),
      remove: (ticket_id, user_id) => del(`mms/ticket/${ticket_id}/follower/${user_id}`)
    }
  },
  status: {
    ...crud('ticket/status')
  },
  reason: {
    ...crud('ticket/reason')
  },
  action: {
    ...crud('ticket/action')
  },
  workOrder: {
    save: (ticket_id, json) => post(`mms/ticket/${ticket_id}/work_order/add`, json)
  }
};

export const workOrder = {
  workOrder: {
    ...crud('work_order'),
    follower: {
      create: (work_order_id, json) => post(`mms/work_order/${work_order_id}/follower`, json),
      remove: (work_order_id, user_id) => del(`mms/work_order/${work_order_id}/follower/${user_id}`)
    },
    task: {
      create: (work_order_id, json) => post(`mms/work_order/${work_order_id}/tasks`, json),
      update: (work_order_id, task_id, json) => put(`mms/work_order/${work_order_id}/tasks/${task_id}`, json),
      remove: (workOrder_id, task_id) => del(`mms/work_order/${workOrder_id}/tasks/${task_id}`),
      removeMultiple: (workOrder_id, task_ids) => post(`mms/work_order/${workOrder_id}/tasks/remove`, task_ids)
    }
  },
  status: {
    ...crud('work_order/status')
  },
  priority: {
    ...crud('work_order/priority')
  },
  maintenanceType: {
    ...crud('work_order/maintenance_type')
  },
  ticket: {
    save: (work_order_id, json) => post(`mms/work_order/${work_order_id}/ticket/add`, json)
  },
  station: {
    save: (work_order_id, json) => post(`mms/work_order/${work_order_id}/station/add`, json)
  }
};


export const survey = {
  topic: {
    ...crud('survey/topic'),
    types: {
      fetchAll: () => get(`mms/survey/topic/type`)
    }
  },
  template: {
    ...crud('survey/template')
  },
  survey: {
    ...crud('survey'),
    fetch: (station_id, date_from, date_to) => get(`mms/survey?station_id=${station_id}&date_from=${date_from}&date_to=${date_to}`)
  }
}

export const event = {
  type: {
    ...crud('event/event-type')
  },
  event: {
    ...crud('event')
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/api.js